import React from 'react';
import '../css/Banner.css'
import axiosInstance from './config/axiosConfig';

export default function Banner() {
  return (
      <header className="banner">
          <img
            src="/images/logo.png"
            alt="Logo"
            className="banner-logo"
          />
          
          <div className="banner-texts">
            <h1 className="banner-title">MONITOREO DE LA GOBERNANZA</h1>
            <h2 className="banner-subtitle">EN SEGURIDAD ALIMENTARIA Y NUTRICIONAL</h2>
          </div>
      </header>
  );
}